import gql from 'graphql-tag';
import { DOCUMENT_TYPE_FRAGMENT } from './fragment';

export const DOCUMENTS_TYPE = gql`
  query DocumentsType($types: [String]) {
    documentsType(types: $types) {
      ...DocumentTypeInfo
    }
  }
  ${DOCUMENT_TYPE_FRAGMENT}
`;
